import { useContext } from 'react'
import Context from './ContactModalContext'

const useShowContactModal = () => {
  const { showModal } = useContext(Context)
  return showModal
}

export default useShowContactModal
